import { useEffect } from 'react'
import { buildUploadedDocumentFiles } from './documentState'
import type { FileState } from './types'

type UseUploadDocumentsStoreSyncArgs = {
  documents: Array<{ documentType: string; fileName?: string | null; status?: string | null }> | undefined
  updateUploadedDocumentFiles: (files: Partial<FileState>) => void
}

export function useUploadDocumentsStoreSync({
  documents,
  updateUploadedDocumentFiles
}: UseUploadDocumentsStoreSyncArgs) {
  useEffect(() => {
    if (!documents || documents.length === 0) {
      return
    }

    const nextFiles = buildUploadedDocumentFiles(documents)

    if (Object.keys(nextFiles).length > 0) {
      updateUploadedDocumentFiles(nextFiles)
    }
  }, [documents, updateUploadedDocumentFiles])
}
